import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const EditEmployee = () => {
    const { id } = useParams(); // Get the employee ID from the URL
    const navigate = useNavigate();

    const [employeeName, setEmployeeName] = useState("");
    const [designation, setDesignation] = useState("");
    const [contact, setContact] = useState("");
    const [DepartmentId, setDepartmentId] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [dateofJoining, setDateofJoining] = useState("");
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        const fetchEmployee = async () => {
            try {
                const token = localStorage.getItem("token");

            const empRes = await axios.get(`https://jerinmjohn.pythonanywhere.com/api/employees/${id}/`, {
                headers: {
                    Authorization: `Token ${token}`, // Add space after 'Token'
                }
            });

            const deptRes = await axios.get("https://jerinmjohn.pythonanywhere.com/api/departments/", {
                headers: {
                    Authorization: `Token ${token}`,
                }
            });
                setEmployeeName(empRes.data.EmployeeName);
                setDesignation(empRes.data.Designation);
                setContact(empRes.data.Contact);
                setDepartmentId(empRes.data.DepartmentID);
                setIsActive(empRes.data.IsActive);
                setDateofJoining(empRes.data.DateofJoining);
                setDepartments(deptRes.data)

            } catch (error) {
                alert("Error fetching employee details")
            }
        };
        fetchEmployee();
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            await axios.put(
                `https://jerinmjohn.pythonanywhere.com/api/employees/${id}/`,
                {
                    EmployeeName: employeeName,
                    Designation: designation,
                    Contact: contact,
                    DepartmentID: DepartmentId,
                    IsActive: isActive,
                    DateOfJoining: dateofJoining,

                },
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },


                }
            );
            alert("Employee updated sucessfully");
            navigate("/dashboard");

        } catch (error) {
            alert("Error updating Employee")

        }

    };
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow p-4">
                        <h2 className="text-center mb-4">EditEmployee</h2>
                        <form onSubmit={handleUpdate}>

                            <div className="mb-3">
                                <label className="form-label"> EmployeeName </label>
                                <input type="text" className="form-control" placeholder="Enter Employee Name"
                                    value={employeeName}
                                    onChange={(e) => setEmployeeName(e.target.value)}
                                    required />

                            </div>

                            <div className="mb-3">
                                <label className="form-label"> Designation </label>
                                <input type="text" className="form-control" placeholder="Enter Designation"
                                    value={designation}
                                    onChange={(e) => setDesignation(e.target.value)}
                                    required />



                            </div>

                            <div className="mb-3">
                                <label className="form-label"> contact </label>
                                <input type="text" className="form-control" placeholder="Enter Contact"
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    required />



                            </div>

                            <div className="mb-3">
                                <label className="form-label"> Department </label>
                                <select className="form-select" value={DepartmentId}



                                    onChange={(e) => setDepartmentId(e.target.value)}
                                    required >

                                    <option value="">Select Department</option>
                                    {departments.map((dept) => (
                                        <option key={dept.DepartmentId} value={dept.DepartmentId}>
                                            {dept.DepartmentName}
                                        </option>




                                    ))}
                                </select>



                            </div>

                            <div className="mb-3">
                                <label className="form-label">Date of DateOfJoining</label>
                                <input type="date" className="form-control" value={dateofJoining}
                                    onChange={(e) => setDateofJoining(e.target.value)}
                                    required />
                            </div>

                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input"
                                    id="isactive" checked={isActive}
                                    onChange={(e) => setIsActive(e.target.checked)} />
                                <label className="form-check-label" htmlFor="isActive">
                                    Is Active
                                </label>
                            </div>

                            <button type="submit" className="btn btn-success w-100">
                                Update Employee
                            </button>

                            <div className="text-center mt-3">
                                <button type="button" className="btn btn-secondary"
                                    onClick={() => navigate("/dashboard")}>
                                    Back to Dashboard
                                </button>
                            </div>
                        </form>

                    </div>

                </div>

            </div >

        </div >
    )
}

export default EditEmployee;


